import './Products.css'

const products = [
  {
    name: 'SocietyHub',
    tagline: 'Smart Society Management Platform',
    description:
      'A full-stack platform for residential communities — digital gate management, visitor tracking, maintenance requests, announcements, and resident communication, all in one place.',
    sector: 'PropTech',
    status: 'Live',
    logo: '/logo.png',
    brand: {
      primary: '#1a6cb5',   // navy blue from logo buildings
      secondary: '#3da64a', // green from logo buildings
      accent: '#f5a623',    // orange from "CONNECT. MANAGE. THRIVE."
    },
    features: [
      'Visitor & Gate Management',
      'Maintenance Request Tracking',
      'Resident Mobile App',
      'Admin & Committee Dashboard',
      'Society Announcements & Notices',
      'Flat & Resident Directory',
      'Staff & Security Management',
      'Emergency SOS Alerts',
      'Parking Management',
      'Digital Document Vault',
    ],
    url: 'https://society-hub.in',
    salesDeck: 'https://society-hub.in/marketing/presentation.html',
  },
]

const Products = () => {
  return (
    <section id="products" className="products section">
      <div className="container">
        <div className="products-header">
          <p className="section-label">OUR PORTFOLIO</p>
          <h2 className="section-title">
            Products Built for <span className="highlight-orange">Real Impact.</span>
          </h2>
          <p className="products-subtitle">
            From idea to production — here's what we've shipped.
          </p>
        </div>

        <div className="products-list">
          {products.map((product, index) => (
            <div
              key={index}
              className="product-card"
              style={{
                '--brand-primary':   product.brand.primary,
                '--brand-secondary': product.brand.secondary,
                '--brand-accent':    product.brand.accent,
              } as React.CSSProperties}
            >

              {/* Left: info */}
              <div className="product-info">
                <div className="product-meta">
                  <span className="product-sector">{product.sector}</span>
                  <span className={`product-status ${product.status.toLowerCase()}`}>
                    <span className="status-dot"></span>
                    {product.status}
                  </span>
                </div>
                <div className="product-title-row">
                  <div className="product-logo-wrapper">
                    <img src={product.logo} alt={`${product.name} logo`} className="product-logo-img" />
                  </div>
                  <div>
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-tagline">{product.tagline}</p>
                  </div>
                </div>
                <p className="product-description">{product.description}</p>
                <div className="product-actions">
                  <a href={product.url} target="_blank" rel="noopener noreferrer" className="btn-visit">
                    Visit Product →
                  </a>
                  {product.salesDeck && (
                    <a href={product.salesDeck} target="_blank" rel="noopener noreferrer" className="btn-deck">
                      View Sales Deck ↗
                    </a>
                  )}
                </div>
              </div>

              {/* Right: features */}
              <div className="product-features-panel">
                <p className="features-label">Key Features</p>
                <ul className="product-features">
                  {product.features.map((feature, i) => (
                    <li key={i} className="product-feature-item">
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Products
